import {
  SendLetterQueryParams,
  UploadAttachResponseDTOSuccess,
} from "@/api/mailbox/models";

import { CreateLetterFormSchema } from "../models/CreateLetterForm.schema";

export const mapFormToQuery = (
  formData: CreateLetterFormSchema,
  attachParams: UploadAttachResponseDTOSuccess[],
): SendLetterQueryParams => {
  return {
    ladyId: Number(formData.ladyId),
    letterText: formData.letterText,
    attachedFiles: attachParams,
  };
};
